/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-unused-vars
const compareDataChanges = (newValues, oldValues) => {
  const newValuesEntriesArray = Object.entries(newValues);
  const filteredNulls = newValuesEntriesArray.filter(([key, value]) => value !== null);
  const dataFiltered = Object.fromEntries(filteredNulls);

  return dataFiltered;
};

export default compareDataChanges;
